export type ResolveChatModalTargetIdParams = {
  autoRenew: boolean;
  isLoading: boolean;
  renewChat: boolean;
  storeChatId: string | null;
  latestId: string | null;
};

/**
 * ChatModal 会话 id 解析：
 * - 续聊/loading 中优先 storeChatId
 * - autoRenew：仅用本次 modal 写入的 storeChatId，永不回落 history latestId
 */
export const resolveChatModalTargetId = ({
  autoRenew,
  isLoading,
  renewChat,
  storeChatId,
  latestId,
}: ResolveChatModalTargetIdParams): string | null => {
  if (autoRenew) {
    return storeChatId;
  }

  return isLoading || renewChat ? storeChatId : latestId;
};
